<div class="org-search-box">
    <div class="org-search-input">
        <input type="text" [(ngModel)]="keyWord"  /> 
        <button class="button primary" (click)="onSearch()">Search</button>
    </div>
    <div class="help-box">
        <span class="help-text">to avoid listing all organizations the keyword must be at least 3 characters long</span>
    </div>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <ul>
                    <li><button>{{errorMessage}}</button></li>
                </ul>
            </div>
        </div>
        <!--<span (click)="closeError()" class="org-search-error-close">(x)</span>-->
    </div>
    <!--<div *ngIf="hasError" class="org-search-error">

        <div class="org-search-error-msg">{{errorMessage}}</div>
        <span (click)="closeError()" class="org-search-error-close">(x)</span>
    </div>-->
    <div class="org-search" *ngIf="'false'">
        <div>
            <table>
                <thead>
                    <tr>
                        <!--<th style="width:10%;"></th>-->
                        <th style="width:30%;">Org Name</th>
                        <th style="width:15%;">Org Short Name</th>
                        <th style="width:15%;">Org Status</th>
                        <th style="width:30%;">Parent Org</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let org of organizations" [ngClass]="{'selected': org.selected}" (click)="onOrgSelect(org)">
                        <!--<td><span *ngIf="!org.selected" class="link" (click)="addOrg(org)">include</span></td>-->
                        <!--<td><input type="radio" /></td>-->
                        <td>{{org.orgName}}</td>
                        <td>{{org.orgShortName}}</td>
                        <td>{{(org.isActive === true)?"Active":"Inactive"}}</td>
                        <td>{{org.orgIPVString}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>